export const MAX_WIDTH_TO_HANDLE_IN_BETWEEN_NEGATIVE_SPACE_IN_LARGE_SCREEN = 400;
